import axios from "axios";
let query = require("querystring");
let base = process.env.API_ROOT; //域名
// localhost.getItem('myrolename')
// 加盟商:franchisee
// 用户:user
// 管理员:admin
// 获取相对路径
function getProPath() {
    var url = document.location.toString();
    var arrUrl = url.split("//");
    var start = arrUrl[1].indexOf("/");
    var relUrl = arrUrl[1].substring(start); //stop省略，截取从start开始到结尾的所有字符
    if (relUrl.indexOf("?") != -1) {
        relUrl = relUrl.split("?")[0];
    }
    relUrl = relUrl.split("/")[1];
    return relUrl;
}
// let road = "/" + getProPath(); //路径
// base = "http://192.168.3.60:8080"; //丛书
// road = "/pgs"; //路径
// base = "https://ceshi.bhnewechat.com"; //丛书
// base = "https://ceshi.bhnewechat.com";
let road = "/pgs"; //路径----不需要注释
export let serverUrl = base + road;
// // 首页栏目配置
// export const getModuleConfig = () => {
//   return axios.get(`${base}${road}/web/publicity/view/getModuleConfig`);
// };
// 获取用户数量、运行天数、行业书等
export const getCustomerNum = params => {
    return axios.get(
        `${base}${road}/web/publicity/view/getCustomerNum`
    );
};
// 获取页面详情信息
export const getPageItemInfo = params => {
    return axios.get(
        `${base}${road}/web/publicity/view/getPageDetailView/${params}`
    );
};
// 获取页面列表
export const getPageViewList = params => {
    return axios.get(
        `${base}${road}/web/publicity/view/getPageViewList?${query.stringify(
            params
        )}`
    );
};

// 获取页面列表(企业交易记录的列表)
export const getPageViewList_2 = params => {
    return axios.get(
        `${base}${road}/web/publicity/view/transaction/trends?${query.stringify(
            params
        )}`
    );
};
// 栏目类型管理-列表
export const getLmlxList = params => {
    return axios.get(
        `${base}${road}/web/publicity/getProgrammaOptions/${params}`
    );
};
// 提交合作申请
export const saveCooperationApply = params => {
    return axios.post(
        `${base}${road}/web/cooperation/saveCooperationApply`,
        params
    );
};
// 访问首页
export const visitFirstPage = () => {
    return axios.get(`${base}${road}/web/publicity/view/visitFirstPage`);
};
// // 考核管理-发布
// export const publishAssessmentManage = params => { return axios.put(`${base}${road}/admin/depart/assessment/publish/${params}`) };

//获取cookie
export const getCookie = function (name) {
    var arr,
        reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if ((arr = document.cookie.match(reg))) {
        return unescape(arr[2]);
    } else {
        return "";
    }
};


// WEBPACK FOOTER //
// ./src/assets/api/api.js